import { Select, Modal } from '@drip/drip-design';

export default function TypeSelect({ value, onChange, levelPlan }) {
  const options = [
    {
      label: '全部商品',
      value: 1,
    },
    {
      label: '商品组',
      value: 2,
    },
    {
      label: '品牌',
      value: 3,
    },
    {
      label: '品类',
      value: 4,
    },
    {
      label: '店铺',
      value: 5,
    },
  ];
  const onValueChange = (val) => {
    if (levelPlan?.find((item) => !!item.amount)) {
      Modal.confirm({
        title: '需清空计划后才修改',
        centered: true,
      });
    } else {
      onChange(val);
    }
  };
  return <Select options={options} value={value} onChange={onValueChange} placeholder="请选择" />;
}
